<template>
    <v-dialog persistent :value="value" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ $t('assign_owner') }}</span>
            </v-card-title>
            <v-card-subtitle v-if="context">
                {{ context }}
            </v-card-subtitle>

            <v-card-text>
                <UserSelect v-model="selectedUser" :initial-user-id="address?.creator_id"></UserSelect>
            </v-card-text>

            <v-card-actions>
                <slot name="actions">
                    <v-spacer></v-spacer>
                    <v-btn text :disabled="loading" @click="$emit('input', false)">{{ $t('cancel') }}</v-btn>
                    <v-btn color="action" text :loading="loading" @click="onSave">{{ $t('save') }}</v-btn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import UserSelect from '@/components/user/Select.vue';
import { Address } from '@/models/Address';
import { ref } from 'vue';

defineProps<{
    value: boolean;
    address: Address;
    loading?: boolean;
    context?: string;
}>();

const emit = defineEmits(['selected']);

const selectedUser = ref(null);

async function onSave() {
    if (selectedUser.value) {
        emit('selected', selectedUser.value);
    }
}
</script>
